import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MODAL_DATA } from 'src/app/helpers/modal.tokens';

@Component({
  selector: 'app-change-project-frequency',
  templateUrl: './change-project-frequency.component.html',
  styleUrls: ['./change-project-frequency.component.scss']
})
export class ChangeProjectFrequencyComponent implements OnInit {
  selectedFrequency: any;

  constructor(
      @Inject(MODAL_DATA) public data: any,
      private dialogRef: MatDialogRef<any>) {
        this.selectedFrequency = this.data.selectedFrequency;
      }

  ngOnInit(): void {
  }

  setFrequency(frequency: any) {
    this.selectedFrequency = frequency;
  }

  close(result: any) {
    this.dialogRef.close({btnValue: result, projectFrequencyUuid: this.selectedFrequency});
  }

}
